import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/hero/02-banner-coffee.avif")